const {PROFILE} = server.env
import profilesInfo from "YConnect/Configs/Others.config"

const getBaseURL = () => profilesInfo.PROFILES[PROFILE || "DEPLOY"] + "/YConnectServer"
export default getBaseURL